import { network } from 'services/network';

export const setHomePage = (params) => {
    const url = `admin/bo/setHomePage?homePageURL=${params.urlPage}`;
    return network.post(url).then((response) => {
        return response.data;
    });
};
